class DateValidator {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.scope = {};

        /**
         * Link
         * @param  {Object} scope
         * @param  {Object} element
         * @param  {Object} attrs
         * @param  {Array} requiredCtrls
         * @return {Void}
         */
        this.link = (scope, element, attrs, modelCtrl) => {
            modelCtrl.$validators.date = (modelValue) => {
                const DATE_REGEXP = /^\d{2}[./-]\d{2}[./-]\d{4}$/;

                if (DATE_REGEXP.test(modelValue) || modelValue === undefined || modelValue === null || modelValue === '') {
                    // input is valid
                    return true;
                }

                // input is invalid
                return false;
            };

        };
    }

    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory() {
        DateValidator.instance = new DateValidator();
        return DateValidator.instance;
    }
}

export default DateValidator;



/** WEBPACK FOOTER **
 ** ./src/app/directives/formValidators/dateValidator.js
 **/